module.exports = __webpack_public_path__ + "static/img/062_TO8_1620_og.a8a6f09.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/062_TO8_1620_og.jpg
// module id = 5/IM
// module chunks = 0